@if (forms) {
  <div class="astral-stack-m">
    @for (form of $any(forms.controls); track form) {
      <section class="astral-section-surface astral-section-surface--compact">
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
          <astral-date-picker [control]="form.controls['transactionDate']"></astral-date-picker>
          <app-money-box class="astral-layout-item" [control]="form.controls['amount']"></app-money-box>
          <astral-input [control]="form.controls['description']"></astral-input>
          <div class="astral-form-adjacent-action">
            <astral-button
              variant="secondary"
              size="small"
              type="button"
              icon="trash"
              labelKey="DELETE_BTN"
              (click)="delete(form)"
            ></astral-button>
          </div>
        </astral-layout-group>
      </section>
    }

    <astral-button
      variant="primary"
      size="small"
      type="button"
      icon="plus"
      labelKey="COOPERATIVE_HOUSING.ADD_INNER_FUND_TRANSACTION"
      (click)="addTransaction()"
    ></astral-button>
  </div>
}
